import { genericToolTip } from '@y42/gojs';
import * as go from 'gojs';
import { OrchestrationUINode } from '../../../../../models/orchestration-diagram.model';

import { OrchestrationDiagramParts } from '../../../../config/orchestration-part-names';
import { visibleInOverview, visibleInStructure } from '../../utils/bindings';

const $ = go.GraphObject.make;

const config = {
  ignore: {
    fill: '#579c73',
    fillOver: '#4e8e69',
    fillPressed: '#457c5c',
  },
  stop: {
    fill: '#cd4e41',
    fillOver: '#bf453f',
    fillPressed: '#af3c38',
  },
  icon: {
    svg: 'M1.31332 10.5938V1.40625C1.31332 1.04395 1.0191 0.75 0.656525 0.75C0.293946 0.75 0 1.04395 0 1.40625V10.5938C0 10.9561 0.294219 11.25 0.656798 11.25C1.01938 11.25 1.31332 10.9574 1.31332 10.5938ZM7.42931 2.97852L9.94494 5.34375H3.28399C2.92032 5.34375 2.62583 5.63906 2.62583 6C2.62583 6.36094 2.92032 6.65625 3.28399 6.65625H9.94494L7.42986 9.0223C7.29259 9.15273 7.22423 9.325 7.22423 9.5C7.22423 9.66149 7.28324 9.82293 7.40295 9.94953C7.65093 10.2136 8.06659 10.2263 8.33073 9.97772L12.0522 6.47772C12.3173 6.22993 12.3173 5.77007 12.0522 5.52233L8.33073 2.02233C8.0665 1.77367 7.65096 1.78649 7.40295 2.05052C7.15314 2.31406 7.16408 2.72969 7.42931 2.97852Z',
  },
};

export const OnFailurePlaceholder = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(
    go.Panel,
    go.Panel.Horizontal,
    { margin: new go.Margin(0, 3), toolTip: ToolTip(), ...props },
    ...bindings,

    // Parts
    IgnorePlaceholder(),
    StopPlaceholder(),
  );

const IgnorePlaceholder = () =>
  $(
    go.Panel,
    go.Panel.Horizontal,
    // Bindings
    visibleOnIgnoreBinding(),

    // Parts
    IgnoreButton({}, [visibleInStructure()]),
    ButtonIcon({}, [visibleInOverview(), buttonIconFillBindingInOverview()]),
  );

const StopPlaceholder = () =>
  $(
    go.Panel,
    go.Panel.Horizontal,
    // Bindings
    visibleOnStopBinding(),

    //Parts
    StopButton({}, [visibleInStructure()]),
    ButtonIcon({}, [visibleInOverview(), buttonIconFillBindingInOverview()]),
  );

const IgnoreButton = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(
    'Button',
    {
      name: OrchestrationDiagramParts.OnFailureButton,
      'ButtonBorder.strokeWidth': 0,
      'ButtonBorder.fill': config.ignore.fill,
      _buttonFillOver: config.ignore.fillOver,
      _buttonFillPressed: config.ignore.fillPressed,
      ...props,
    },

    ...bindings,

    // Parts
    ButtonIcon({}, [buttonIconFillBindingInStructure()]),
  );

const StopButton = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(
    'Button',
    {
      name: OrchestrationDiagramParts.OnFailureButton,
      'ButtonBorder.strokeWidth': 0,
      'ButtonBorder.fill': config.stop.fill,
      _buttonFillOver: config.stop.fillOver,
      _buttonFillPressed: config.stop.fillPressed,
      ...props,
    },

    ...bindings,

    // Parts
    ButtonIcon({}, [buttonIconFillBindingInStructure()]),
  );

const ButtonIcon = (props: Record<string, unknown> = {}, bindings: go.Binding[] = []) =>
  $(
    go.Shape,
    {
      width: 16,
      height: 16,
      strokeWidth: 0,
      margin: new go.Margin(4),
      geometry: go.Geometry.parse(config.icon.svg, true),

      ...props,
    },
    ...bindings,
  );

const ToolTip = () =>
  genericToolTip({ colors: { fill: 'white', stroke: '#666666' } }, [
    new go.Binding('text', '', (node: OrchestrationUINode) =>
      node.onFailure ? OnFailureTooltipMessages[node.onFailure] : '',
    ),
  ]);

//Bindings
const visibleOnIgnoreBinding = () =>
  new go.Binding('visible', '', (node: OrchestrationUINode) => node.onFailure === 'ignore');

const visibleOnStopBinding = () =>
  new go.Binding('visible', '', (node: OrchestrationUINode) => node.onFailure === 'stop');

const buttonIconFillBindingInStructure = () => new go.Binding('fill', '', () => 'white');

const buttonIconFillBindingInOverview = () =>
  new go.Binding('fill', '', (node: OrchestrationUINode) =>
    node.onFailure === 'stop' ? config.stop.fill : config.ignore.fill,
  );

const OnFailureTooltipMessages: Record<'stop' | 'ignore', string> = {
  stop: 'DAG will stop when this node fails. Click to Toggle',
  ignore: 'DAG will keep running when this node fails. Click to Toggle',
};
